module.exports = __webpack_public_path__ + "img/header-background-2.443a3d75.png";